import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Event } from "./components/eventpage";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import styles from 'react-responsive-carousel/lib/styles/carousel.min.css';
import Carousel1 from "./components/Carousel";
import { Schedule } from "./components/schedule";
import { Sponsors } from "./components/sponsors";
import Comingpage from "./components/coming";
import Home from "./components/home";
import { Routes, Route, Outlet, Link, BrowserRouter } from "react-router-dom";

import ErrorPage from "./components/errorpage"
import SponsorsPage from "./components/sponsorpage"
import { Advisorybody } from "./components/Advisorybody";
import { Submit } from "./components/Submit";
import { Seo } from "./components/Seo";
export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});


function App() {
  return (
    <div>
      <Navigation/>
      <BrowserRouter>
      <Routes>
        <Route path="/" element={<><Seo title="Peer-Reviewed Bengali Research Journal" /><Home /></>}/>
        <Route path="/advisory-body" element={<><Seo title="Advisory Body" description="Meet the distinguished scholars on the Advisory Body of Annwesha Research Journal." path="/advisory-body" /><Advisorybody /></>}/>
        <Route path="/submit" element={<><Seo title="Submit a Research Article" description="Submission guidelines for original research articles to Annwesha, a peer-reviewed Bengali research journal." path="/submit" /><Submit /></>}/>
        <Route path="/*" element={<ErrorPage/>}/>
      </Routes>
      </BrowserRouter>
      </div>
  );
}

export default App
